import React, { useEffect, useState, useRef } from "react";
import ModalContent from "/Foundation/Common/code/Views/Foundation/Common/ModalContent"
import Spinner from "/Foundation/React/code/Components/Extranet/Spinner";
const SparePartAddToCartButton = ({ sparePart, addToCart, translations, dealerLocatorLink, itemResponseData }) => {
    const isExtranet = window._THULEDATA.SitecoreSiteName === "Extranet";
    if (!sparePart?.Id || (!isExtranet && !window._THULEDATA.isB2CEnabled))
        return null;

    const [amount, setAmount] = useState(1);
    const [showServicePartModal, setShowServicePartModal] = useState(false);
    const [showServicePartRepairModal, setShowServicePartRepairModal] = useState(false);
    const [isPurchasable, setIsPurchasable] = useState(sparePart.ButtonType == "InStock");
    const input = useRef();
    useEffect(() => {
        if (!isNaN(amount))
            return;

    }, [amount]);

    useEffect(() => {
        if (!isExtranet)
            return;
        const isValidResponseForItem = itemResponseData && !itemResponseData.Error && itemResponseData.HasSalesPrice && itemResponseData.DeliveryDate ? true : false;
        setIsPurchasable(isValidResponseForItem);
    }, [itemResponseData]);

    const getExtranetButtonContent = () => {
        if (!itemResponseData)
            return <div><Spinner /></div>;
        if (!itemResponseData.DeliveryDate)
            return translations?.OutOfStock;
        if (isPurchasable)
            return translations?.AddToCart;
        return null;
    }
    const onClickAddToCart = () => {
        if (!isPurchasable)
            return;
        addToCart(sparePart, amount);
    }

    const getButtonBasedOnType = (sparePart) => {
        if (isExtranet) {
            return <button onClick={onClickAddToCart} className={`cartButton btn btn-sm thule-btn-default ${!itemResponseData ? "pe-none" : ""}`}>{getExtranetButtonContent()}</button>;
        }

        switch (sparePart?.ButtonType) {
            case 'ServicePart':
                return <button onClick={() => { setShowServicePartModal(true) }} className="cartButton btn btn-sm thule-btn-tertiary"><i className="le-icon-info me-3"></i>{translations.ModalHeader}</button>;
            case 'ServicePartRepair':
                return <button onClick={() => { setShowServicePartRepairModal(true) }} className="cartButton btn btn-sm thule-btn-tertiary"><i className="le-icon-info me-3"></i>{translations.ServicePartsRepairHeader}</button>;
            case 'InStock':
                return <button onClick={onClickAddToCart} className="cartButton btn btn-sm thule-btn-default" disabled={!isPurchasable}>{translations.AddToCart}</button>;
            case 'OutOfStock':
                return <button className="cartButton btn btn-sm thule-btn-default" disabled={true}>{translations.OutOfStock}</button>;
            case 'Unavailable':
                return null;
            case 'Discontinued':
                return <div className="discontinued heading6 text-color--pitchBlack">{translations.Discontinued}</div>;
            default:
                return null;
        }
    }

    return <div className={`sparePartAddToCartButton ${isExtranet ? 'extranet' : ''}`}>
        {isExtranet && <div className="d-flex position-relative sparePartAddToCartButton__inputWrapper">
            <button disabled={!isPurchasable} onClick={(e) => setAmount(amount > 1 ? amount - 1 : amount)} className="btn decrement px-3"><i className="le-icon-minus"></i></button>
            <input
                disabled={!isPurchasable}
                ref={input}
                type="number"
                step="1"
                min="1"
                pattern="\d+"
                value={amount}
                onChange={(e) => setAmount(e.currentTarget.value)}
                id={`sparePartAddToCartButton_input_${sparePart.ErpOutdoor}`}
            />
            <button disabled={!isPurchasable} onClick={(e) => { setAmount(amount + 1) }} className="btn increment px-3"><i className="le-icon-plus"></i></button>
        </div>}
        {<ModalContent SetShowModal={setShowServicePartModal} ShowModal={showServicePartModal} Title={translations?.ModalHeader} Content={() => <div>{translations?.ModalText}</div>} Link={() => <a href={dealerLocatorLink} target="_blank">{translations?.DealerLocatorLinkText}</a>} />}
        {<ModalContent SetShowModal={setShowServicePartRepairModal} ShowModal={showServicePartRepairModal} Title={translations?.ServicePartsRepairHeader} Content={() => <div>{translations?.ServicePartsRepairText}</div>} Link={() => <a href={dealerLocatorLink} target="_blank">{translations?.DealerLocatorLinkText}</a>} />}
        <div className="cartButtonContainer">
            {getButtonBasedOnType(sparePart)}
            {(!isExtranet && sparePart.StockStatus && sparePart.ButtonType == "OutOfStock") && <span className="paragraph--xs">{sparePart?.StockStatus}</span>}
        </div>
    </div>
}
export default SparePartAddToCartButton;